import React from 'react';

export default function Program() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Program</h1>
      <p className="text-gray-500">Halaman Program</p>
    </div>
  );
}
